import React from 'react';
import styles from './styles.scss';
import useChangeLanguage, { LANGUAGES } from '../../i18n/LangueageSwitcher';
import iconCheckMark from 'assets/images/check-mark.svg';
import { useDispatch } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { useTranslation } from 'react-i18next';

const LanguageModal = () => {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage } = useChangeLanguage();
  const dispatch = useDispatch();

  const handleChangeLanguage = (newCode) => {
    if (newCode !== currentLanguage) {
      changeLanguage(newCode);
    }
    dispatch(setPopUp());
  };

  return (
    <div className={styles.Modal}>
      <div className={styles.ModalTitle}>{t('components.header.user.language')}</div>
      <div className={styles.Separator} />
      <div className={styles.LanguageList}>
        {LANGUAGES.map(({ code, label, country }) => (
          <div
            key={code}
            className={styles.LanguageItem}
            onClick={() => handleChangeLanguage(code)}
          >
            <div className={styles.Text}>
              <span>{label}</span>
              <span className={styles.Country}>{`(${country})`}</span>
            </div>
            {currentLanguage === code && <img className={styles.CheckMark} src={iconCheckMark} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageModal;



// WEBPACK FOOTER //
// ./src/components/Language/LanguageModal.jsx